let isFromNavigationBar = false;
let activeClickSection;

$(document).ready(function () {
    // Cache jQuery elements
    const $window = $(window);
    const $body = $("body");
    const $header = $(".header-content");
    const $footer = $("#footercontent");
    const $stickyNavSections = $(".js-sticky-nav-section");

    if ($stickyNavSections.length === 0) {
        return;
    }

    // Template for the navigation bar
    const $stickyNav = $("<div class='sticky-navigation js-sticky-navigation' />");
    const $stickyNavList = $("<ul class='sticky-navigation__list js-sticky-navigation-list' />");
    const $activeButton = $("<button class='sticky-navigation__active-button js-active-button'></button>");

    $activeButton.attr("aria-label", "Active Button");

    $activeButton.on("click", () => {
        $stickyNav.toggleClass("show");
    });

    $stickyNavSections.each((index, section) => {
        const $sectionButton = $(`<button class="sticky-navigation__button js-sticky-nav-button" data-target="${section.id}">${section.dataset.title}</button>`);
        $($stickyNavList).append($("<li class='sticky-navigation__item'></li>").html($sectionButton));

        // Event handling for clicking on a link
        $sectionButton.on("click", (event) => {
            if (!$(event.currentTarget).hasClass("active")) {
                const scrollPos = $(`#${section.id}`).offset().top - ($body.hasClass("isSticky") ? $header.outerHeight(true) : 0);
                isFromNavigationBar = true;
                activeClickSection = section;

                $("html, body").animate({
                    "scrollTop": scrollPos,
                }, 500);
            }
        });
    });

    $("body").append($stickyNav.append($stickyNavList).append($activeButton));
    $window.on("scroll", $window[0].debounce(() => {
        const scrollPosition = $window.scrollTop();
        const stickyIt = scrollPosition > 0 && !$footer.isInViewport();
        const sectionActiveList = [];

        $stickyNav.toggleClass("is-sticky", stickyIt);
        $(".js-sticky-nav-button", $stickyNav).removeClass("active");

        $stickyNavSections.each((index, section) => {
            if ($(section).isInViewport()) {
                sectionActiveList.push(section);
            }
        });

        if (sectionActiveList.length) {
            const activeSection = getActiveSection(sectionActiveList);
            const $activeSectionButton = $(".js-sticky-nav-button[data-target='" + $(activeSection).attr("id") + "']", $stickyNav);

            $activeSectionButton.addClass("active");
            $activeButton.text(activeSection.dataset.title);
        }

        isFromNavigationBar = false;
    }, 100));
});

/**
* Returns the active section of the page
* @param {object} sections - array of sections
* @returns {object} - the active section
*/
function getActiveSection(sections) {
    if (isFromNavigationBar && activeClickSection) {
        return activeClickSection;
    } else {
        return sections.reduce(function (activeSection, currentSection) {
            const activeSectionSize = getVisibleSize($(activeSection));
            const currentSectionSize = getVisibleSize($(currentSection));

            if (activeSectionSize.height > currentSectionSize.height) {
                if (currentSection.clientHeight === currentSectionSize.height) {
                    return currentSection;
                }
                return activeSection;
            }
            return currentSection;
        });
    }
}

/**
* Gets the visible size of the given section
* @param {object} $section - jQuery object of the section
* @returns {object} - an object containing the visible width and height of the section
*/
function getVisibleSize($section) {
    let $window = $(window);
    let bounds = $section.offset();
    let viewport = {
        top: $window.scrollTop(),
        left: $window.scrollLeft()
    };

    viewport.right = viewport.left + $window.width();
    viewport.bottom = viewport.top + $window.height();
    bounds.right = bounds.left + $section.outerWidth();
    bounds.bottom = bounds.top + $section.outerHeight();

    let visibleBounds = {
        left: Math.max(bounds.left, viewport.left),
        right: Math.min(bounds.right, viewport.right),
        top: Math.max(bounds.top, viewport.top),
        bottom: Math.min(bounds.bottom, viewport.bottom)
    };

    let visibleWidth = visibleBounds.right - visibleBounds.left;
    let visibleHeight = visibleBounds.bottom - visibleBounds.top;

    return {
        width: visibleWidth,
        height: visibleHeight
    };
}
